import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { AppSettingPermissionsSummaryParams, AppSettingServices } from "@/services/bedrock";

export const useAppSettings = (params?: AppSettingPermissionsSummaryParams) => {
  const { data: appSettingPermissionsSummary } = useQuery({
    queryKey: ["appSettingPermissionsSummary", params],
    queryFn: async () => {
      return AppSettingServices.getAppSettingPermissionsSummary(params);
    },
    meta: { persist: true },
    staleTime: 1000 * 60, // 1 minute
    gcTime: 1000 * 60 * 60 * 13, // 13 hours
  });

  const hasAppSetting = useCallback(
    (appSettingId: string, params?: AppSettingPermissionsSummaryParams): boolean | undefined => {
      return appSettingPermissionsSummary?.[appSettingId];
    },
    [appSettingPermissionsSummary]
  );

  return { hasAppSetting, appSettingPermissionsSummary };
};
